module.exports = __webpack_public_path__ + "i18n/zh-CN.82f7b1b3e98c0c0b999887ccbcf10438.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1295
// module chunks = 60